export const favoritesTeamId = 999;
export const unscheduledTeamId = 998;